/* eslint-disable @typescript-eslint/naming-convention */
import type { Func } from "@react-awesome-query-builder/core";

const UNIFIED_RANGE_BETWEEN: Func = {
    label: "DATE IN BETWEEN",
    returnType: "number",

    args: {
        start: {
            label: "Start",
            type: "number",
            valueSources: ["value"],
        },
        end: {
            label: "End",
            type: "number",
            valueSources: ["value"],
        },
        target: {
            label: "Target Date",
            type: "date",
            valueSources: ["value", "field", "func"],
        },
    },

    jsonLogic: (args) => ({
        and: [
            {
                UNIFIED_RANGE_BETWEEN: {
                    start: args.start,
                    end: args.end,
                    startVar: { var: "Start_Unified_Sync_Time" },
                   
                    target: args.target,
                },
            },
        ],
    }),

    formatFunc: (formattedArgs) =>
        `UNIFIED_RANGE_BETWEEN(${formattedArgs.start}, ${formattedArgs.end}, ${formattedArgs.target})`,

    sqlFormatFunc: (formattedArgs) =>
        `UNIFIED_RANGE_BETWEEN(${formattedArgs.start}, ${formattedArgs.end}, ${formattedArgs.target})`,
};

export default UNIFIED_RANGE_BETWEEN;
